import React from 'react';
import { Award, Users, Wrench, MapPin } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const AboutSection = () => {
  const stats = [
    {
      icon: Award,
      value: 'Profesional',
      label: 'Servicio de Calidad'
    },
    {
      icon: Users,
      value: 'Confiable',
      label: 'Atención Personalizada'
    },
    {
      icon: Wrench,
      value: 'Equipado',
      label: 'Tecnología Moderna'
    },
    {
      icon: MapPin,
      value: 'Mendoza - Zona este',
      label: 'Zona de Cobertura'
    }
  ];

  return (
    <section id="nosotros" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image */}
          <div className="relative">
            <div className="relative h-[400px] lg:h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_crane-services-4/artifacts/ya87o7d3_Screenshot_20260222_034045_Gallery.jpg"
                alt="SIA Grúas en acción"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent"></div>
            </div>
          </div>

          {/* Right Column - Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Sobre Nosotros
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              SIA Grúas es una empresa dedicada al traslado profesional de vehículos y maquinaria 
              en Mendoza. Contamos con la experiencia y equipamiento necesario para brindar un 
              servicio seguro y confiable.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Nuestro compromiso es ofrecer soluciones rápidas y efectivas para el traslado de 
              vehículos ligeros, pesados y maquinaria industrial, garantizando la integridad de 
              sus bienes en cada servicio.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-4">
              {stats.map((stat, index) => (
                <Card key={index} className="border-gray-200 hover:shadow-lg transition-shadow">
                  <CardContent className="p-4">
                    <div className="flex items-center space-x-3">
                      <div className="p-2 bg-gray-100 rounded-lg">
                        <stat.icon className="w-5 h-5 text-gray-900" />
                      </div>
                      <div>
                        <p className="font-bold text-gray-900 text-sm">
                          {stat.value}
                        </p>
                        <p className="text-xs text-gray-600">
                          {stat.label}
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
